import React from "react";
import { Row, Col } from "react-bootstrap";

export default function TaskSummaryBlog() {
  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: "rgba(1, 21, 47, 0.3)" }}
    >
      <div className="element-area">
        <div className="demo-view">
          <div className="container-fluid pt-0 ps-0 pe-lg-4 pe-0">
            <Row>
              <Col xl={12}>
                <div className="profile-form">
                  <h3 style={{ color: "#AAAAAA" }}>
                    <b>Happy New Year! It’s Time to Make Your Predictions!</b>
                  </h3>
                  <h6>&nbsp;</h6>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><i>Making your Predictions!</i></b>
                  </h4>
                  <h6>&nbsp;</h6>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><u>Group Member:</u></b>
                  </h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Can you predict the future? Select the Predictions icon at
                    the bottom of the screen.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    You will see prompted questions for the coming year, thanks
                    to your group admin! Go ahead and answer the questions
                    predicting what YOU think will happen in the New Year.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    If you can’t enter your answers, Stay Tuned! Your Admin
                    needs to open the answer fields. Refresh your screen.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    After you have entered your predictions for each question,
                    select “Save Answers”. Now your predictions are sealed and
                    locked! No peeking until next New Year’s Eve!
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    On next year’s New Year's Eve, your Group Admin will do the
                    “Big Reveal” and you will see your sealed responses again.
                    How well did you predict the answers to the questions? Score
                    your responses by selecting if you were 0%, 25, 50%, 75%, or
                    100% correct. Be sure to select “Save Scores” after you
                    score your predictions.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Select the Home icon to see your total predictions scoring.
                  </h5>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><i>Scoring</i></b>
                  </h4>
                  <ul style={{ padding: "revert" }}>
                    <li style={{ listStyle: "disc" }}>
                      <h5 style={{ color: "#AAAAAA" }}>
                        Predictions scoring is the sum of all your scores and
                        based on 100 points per question. It’s an honor system –
                        let’s not take this too seriously! Most questions are
                        yes or no, meaning 0% or 100% achieved. For some
                        questions you may have multiple answers and use your
                        best judgement for scoring. Remember, it’s supposed to
                        be fun!
                      </h5>
                    </li>
                  </ul>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Your predictions answers are scored based on your own
                    self-assessment of how accurately you predicted the future.
                    Well done!
                  </h5>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><i>Sharing Pictures</i></b>
                  </h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    You can add pictures to your group carousel display of
                    photos. Within your group, select the Announcement icon and
                    select “Add Yours”. You can add a note and upload your photo
                    by selecting choose file.
                  </h5>
                  <h4 style={{ color: "#AAAAAA" }}><b><i>Create a New Group</i></b></h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Click on your profile and select “Create a new Group”. Enter
                    a group name, select “Add”. Group Admin menu options will
                    now be available for you to add group members and to create
                    your group’s predictions questions.
                  </h5>
                  <h6>&nbsp;</h6>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><u>Group Admin:</u></b>
                  </h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    A few quick tips if you are a Group Admin
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Select Admin options from the menu at the top right of the
                    page after you login.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    <b>Create your group’s Predictions Question list:</b> A
                    standard template has been created to get you started! You
                    can use the standard questions already created or you can
                    add new questions and delete questions. To see the standard
                    questions, select Questions template predictions and the
                    upcoming new year. A list of standard questions will appear.
                    Next, modify, delete or add any questions. When you have
                    your list ready, select “Publish.”
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    <b>Create a new group:</b> enter a group name, select
                    “Add”.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    <b>Invite a new group member:</b> select your group name
                    from the drop-down menu, enter your new member’s email
                    address and select “Send Invitation”. Enter an email address
                    for each new member you want to add to the group.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Now you are ready to make your predictions with your group!
                  </h5>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><i>Seal the Predictions</i></b>
                  </h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    After all group members have entered their predictions,
                    select “Lock” to lock the predictions. Answers remain locked
                    until the big reveal at next year’s party.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    If the Group Admin doesn’t lock the predictions, they will
                    be locked at the end of 60 days by the Global Administrator.
                  </h5>
                  <h4 style={{ color: "#AAAAAA" }}>
                    <b><i>The Big Reveal</i></b>
                  </h4>
                  <h5 style={{ color: "#AAAAAA" }}>
                    At the next New Year’s Eve party, the Group Admin will do
                    the “Big Reveal” so your members can see their answers and
                    score their results.
                  </h5>
                  <ul style={{ padding: "revert" }}>
                    <li style={{ listStyle: "disc" }}>
                      <h5 style={{ color: "#AAAAAA" }}>
                        select “Reveal” on the predictions page for the
                        current year;
                      </h5>
                    </li>
                    <li style={{ listStyle: "disc" }}>
                      <h5 style={{ color: "#AAAAAA" }}>
                        you will see “Start your NYE Party”, select “Ok”;
                      </h5>
                    </li>
                    <li style={{ listStyle: "disc" }}>
                      <h5 style={{ color: "#AAAAAA" }}>
                        slide the button from “Sealed” to “Reveal”, the prompt
                        “Ready for the Big Reveal?” appears, select “Ok”.
                      </h5>
                    </li>
                  </ul>
                  <h5 style={{ color: "#AAAAAA" }}>
                    After all members have scored how well they predicted the
                    future, it’s time to close the year. Select “Close the
                    “20XX” Party.
                  </h5>
                  <h5 style={{ color: "#AAAAAA" }}>
                    Be sure to create your next year’s predictions questions!
                  </h5>
                  <h6>&nbsp;</h6>
                  &nbsp;
                </div>
                &nbsp;
              </Col>
            </Row>
            &nbsp;
          </div>
          &nbsp;
        </div>
        &nbsp;
      </div>
    </div>
  );
}
